import React from "react"
import { Container } from "react-bootstrap"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Front from "../components/front"
import EmailCapture from "../components/emailCapture"

import { config } from "@fortawesome/fontawesome-svg-core"
import "@fortawesome/fontawesome-svg-core/styles.css"
config.autoAddCss = false

const IndexPage = () => (
  <Layout pageInfo={{ pageName: "index" }}>
    <SEO title="SaaS Metrics Calculators" keywords={[`saas`, `calculators`, `metrics`]} />
    <Container>
      <Front />
      <EmailCapture />
    </Container>
  </Layout>
)

export default IndexPage
